import { createApi } from '@reduxjs/toolkit/query/react';

import { ApiResponse } from '../../../model';
import { API_CONSTANTS } from '../../../utils/constants';

import type { ChangePasswordRequest } from './model';
import { baseQueryWithReauth } from '../../../apis/baseQuery';

export const changePasswordApi = createApi({
  reducerPath: 'changePasswordApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    changePassword: build.mutation<ApiResponse<string>, ChangePasswordRequest>({
      query: (body) => ({
        url: API_CONSTANTS.AUTH.CHANGE_PASSWORD_URL,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useChangePasswordMutation } = changePasswordApi;
export default changePasswordApi;
